import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonContent, IonHeader, IonFooter, useIonRouter } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';
import { AddSupplierModal } from '../../../zInternal_Features/merchant/components/Modal_AddSupplier';

import '../../../css/layout.css';

import { Preferences } from '@capacitor/preferences'

import { useHistory} from "react-router-dom";


function setFunction_initialSetup(event) {

    Preferences.set({
        key: 'initial_setup',
        //value: event,
        value: JSON.stringify({
            setup_id: event[0],
            details: event[1],
            status: event[2],
            dateCreated: event[3],
            lastModified: event[4],
        })

    })

}

function setFunction_tutorial(event) {


    alert("in SET FUNCTION TUTORIAL");
    alert(event);

    Preferences.set({
        key: 'selected_tutorial',
        //value: event,
        value: JSON.stringify({
            tutorial_id: event[0],
            tutorial_name: event[1],
            details: event[2],
            status: event[3],
            dateCreated: event[4],
            lastModified: event[5],
        })

    })

}

export function CreateInventoryItemModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 
    let [showSupplierModal, setShowSupplierModal] = useState(false);

    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);

    let [supplierName, setSupplierName] = useState('');
    let [supplierPhone, setSupplierPhone] = useState('');
    let [supplierAddress, setSupplierAddress] = useState('');
    let [supplierCity, setSupplierCity] = useState('');
    let [supplierCountry, setSupplierCountry] = useState('');


    let createItemNameRef = useRef('');
    let createItemDescriptionRef = useRef('');
    let vendorPartNumRef = useRef('');
    let vendorNameRef = useRef('');
    let vendorPhoneNumberRef = useRef('');
    let vendorAddressRef = useRef('');
    let vendorCityRef = useRef('');
    let vendorCountryRef = useRef('');
    let itemCostPerUnitRef = useRef();
    let itemQtyInStockRef = useRef();
    let qtyUnitsRef = useRef('qty');

    let [searchResults, setSearchResults] = useState([]);

    let history = useHistory();
    let router = useIonRouter();

    function handleRoute(event)
    {
        //alert(authenticatedMerchent_context.authenticated);

        //history.push(event);
        window.location.pathname = event;

    }

    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setSelectedFile(noImageFile);

            alert("No Attachment Option checked");

        })
    }

    function searchSupplierList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);

    }


    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {
        //let searchData = document.getElementById('searchInventoryItem').value;
        //let optionsData = document.getElementById('searchInventoryItemsList').childNodes;


        /*for (let i = 0; i < optionsData.length; ++i)
        {
            let remove = document.getElementsByClassName('forDontRemoveProjectSearch');

            while(remove.length > 0)
            {
                remove[0].parentNode.removeChild(remove[0]);
            }
        }*/


        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'name')
        {
            /*
            formData.append('Tracker', '74002S_N');
            formData.append('user', acctID);
            formData.append('xSupplierSearchName', searchData);
            */

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
             /*
            formData.append('Tracker', '74002S_P');
            formData.append('user', acctID);
            formData.append('xSupplierSearchPhone', searchData);
            */

            Tracker = '74002S_P';

        }


        /*const requestOptions = {
            method: 'POST',
            credentials: 'include',
            body: formData
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSupplierSearchName: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'name')
                                {
                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }
                                else if(searchCategory === 'phone')
                                {

                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                }
                            }
                    })
    }


    function createInventoryItem(e)
    {

        e.preventDefault();


        //alert('In createInventoryItem');
        //alert(createItemNameRef.current.value);
        //alert(createItemDescriptionRef.current.value);
        //alert(vendorPartNumRef.current.value);
        //alert(supplierName);
        //alert(supplierPhone);
        //alert(supplierAddress);
        //alert(supplierCity);
        //alert(supplierCountry);
        //alert(itemCostPerUnitRef.current.value);
        //alert(itemQtyInStockRef.current.value);
        //alert(selectedFile);
        //alert(enteredPassword);

        /*
        let formData = new FormData();
        formData.append('Tracker', 74400);
        formData.append('user', acctID);
        formData.append('xInventoryItemName', createItemNameRef.current.value);
        formData.append('xInventoryItemDescription', createItemDescriptionRef.current.value);
        formData.append('xInventoryVendorPartNum', vendorPartNumRef.current.value);
        formData.append('xInventoryVendorName', supplierName);
        formData.append('xInventoryVenderPhoneNumber', supplierPhone);
        formData.append('xInventoryVendorAddress', supplierAddress);
        formData.append('xInventoryVendorCity', supplierCity);
        formData.append('xInventoryVendorCountry', supplierCountry);
        formData.append('xInventoryItemCostPerUnit', itemCostPerUnitRef.current.value);
        formData.append('xInventoryItemQtyInStock', itemQtyInStockRef.current.value);
        formData.append('xImageFile', selectedFile);
        formData.append('xEnterAdminPassword', enteredPassword);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74400_retail',
                user: acctID,
                xInventoryItemName: createItemNameRef.current.value,
                xInventoryItemDescription: createItemDescriptionRef.current.value,
                xInventoryVendorPartNum: vendorPartNumRef.current.value,
                xInventoryVendorName: vendorNameRef.current.value,
                xInventoryVenderPhoneNumber: vendorPhoneNumberRef.current.value,
                xInventoryVendorCity: vendorCityRef.current.value,
                xInventoryVendorCountry: vendorCountryRef.current.value,
                xInventoryItemCostPerUnit: itemCostPerUnitRef.current.value,
                xInventoryItemQtyInStock:  itemQtyInStockRef.current.value,
                xInventoryItemQtyUnits: qtyUnitsRef.current.value,
                xImageFile: selectedFile,
                //xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let rows = data.toString().split('~~~');
            let cols = rows[0].split('|');

            //alert(authenticatedMerchent_context.initialSetup?.details?.step_2);
            //alert(data);
    
            if(authenticatedMerchent_context.selectedTutorial?.tutorial_id == "1" && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false && cols[1].trim() === 'ITEM_CREATED')
            {
                alert('TUTORIAL ITEM_CREATED');
                updateSelectedTutorial({step_1: true, step_2: true});
                window.location.href = '/retail_merchantMainPageApp';
            }
            else if(authenticatedMerchent_context.initialSetup?.details?.step_2 == false && cols[1].trim() === 'ITEM_CREATED')
            {
                //alert('INITIAL SETUP ITEM_CREATED');
                updateInitialSetup({step_1: true, step_2: true, step_3: authenticatedMerchent_context.initialSetup?.details?.step_3});
                //window.location.href = '/retail_merchantMainPageApp';
            }
            else if(cols[1].trim() === 'ITEM_CREATED')
            {
                alert('ITEM_CREATED');
                window.location.href = '/retail_merchantMainPageApp';
            }
            else if(cols[1].trim() !== 'ITEM_CREATED')
            {
                alert('ERROR CREATING ITEM');
                window.location.href = '/retail_merchantMainPageApp';
            }
        })
        .catch(error => {
            console.error(error);
        })
        //setAdminPasswordCreateInventoryItemModal(false);
    }


    function updateInitialSetup(event) {

        //alert("in updateInitialSetup");
        //alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '74003B_update_initialSetup');
         formData.append('user', acctID);
         formData.append('xInitialSetup_id', authenticatedMerchent_context.initialSetup.setup_id);
         formData.append('xInitialSetup_details', JSON.stringify(event));
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
         fetch(baseURL+"retail_merchantAcct_argsjqApp",requestOptions)
         .then(res => res.text())
         .then(res => {
 

            let rows = res.toString().split('~~~');
            let lines3 = rows[0].split('|');
            
             setFunction_initialSetup([lines3[0], lines3[1], lines3[2], lines3[3]]);

             let initialSetupParsed = {};
                
             try {
             initialSetupParsed = JSON.stringify({
                 setup_id: lines3[0],
                 details: lines3[1],
                 status: lines3[2],
                 dateCreated: lines3[3],
                 lastModified: lines3[4],
             })
                 ? JSON.parse(JSON.stringify({
                     setup_id: lines3[0],
                     details: lines3[1],
                     status: lines3[2],
                     dateCreated: lines3[3],
                     lastModified: lines3[4],
                 })) : {};

             if (typeof initialSetupParsed.details === 'string') {
                 initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
             }
             } catch (e) {
             console.warn('Error parsing initialSetup:', e);
             initialSetupParsed = {};
             }


          authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 


             alert("INITIAL SETUP STEP COMPLETED.  PLEASE PROCEED TO NEXT STEP");

            handleRoute('/retail_merchantMainPageApp');
            //props.closeModal(false);
         })
     }
     
     function updateSelectedTutorial(event) {

        alert("in updateSelectedTutorial");
        alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '33_update_selectedTutorial');
         formData.append('user', acctID);
         formData.append('xTutorial_id', authenticatedMerchent_context.selectedTutorial?.tutorial_id);
         formData.append('xTutorial_details', JSON.stringify(event));
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
         fetch(baseURL+"retail_merchantAcct_argsjqApp",requestOptions)
         .then(res => res.text())
         .then(res => {
 

            alert("After UPDATING - Tutorial")
            alert(res);

            let rows = res.toString().split('~~~');

            let rowLength = rows.length;

            let cols = rows[0].split('|');


            setFunction_tutorial([event[0], event[1], cols[0], cols[1], event[4], event[5]]);

            let selectedTutorialParsed = {};

            try {
            selectedTutorialParsed = JSON.stringify({
                setup_id: event[0],
                name: event[1],
                details: cols[0],
                status: cols[1],
                dateCreated: event[4],
                lastModified: event[5],
            })
                ? JSON.parse(JSON.stringify({
                    setup_id: event[0],
                    namne: event[1],
                    details: cols[0],
                    status: cols[1],
                    dateCreated: event[4],
                    lastModified: event[5],
                })) : {};

            if (typeof selectedTutorialParsed.details === 'string') {
                selectedTutorialParsed.details = JSON.parse(selectedTutorialParsed.details);
            }
            } catch (e) {
            console.warn('Error parsing selectedTutorial:', e);
            selectedTutorialParsed = {};
            }


         authenticatedMerchent_context.changeSelectedTutorial(selectedTutorialParsed); 


             alert("UPDATE COMPLETE");

             history.push('/retail_merchantMainPageApp');
            //props.closeModal(false);
         })
     }
     
    function selectedFileHandler(event)
    {
        //alert('In onSelectedFile');
        //alert(event);

        setSelectedFile(event);

    }

    let timeout;

    function handleInput(event) {

        document.getElementById('searchSupplierNameList').innerHTML = '';
        document.getElementById('searchSupplierPhoneNumberList').innerHTML = '';

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchSupplierList(event), 2000); // Set a new timeout
    
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //alert('In onSubmitPasswordHandler');
        //alert(enteredPassword);

        //setEnteredPassword(event);
        createInventoryItem(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    //alert("Create Inventory Item");


    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal}>
                    <form onSubmit={createInventoryItem}>

                        <IonHeader style={{color: 'black'}}>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='12'>
                                        <h2>CREATE ITEM </h2>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonHeader>
                        <IonContent className='grid_content'>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel className="form-label" position="stacked">Item Name: </IonLabel>
                                                <IonInput className='professional-input' placeholder='Enter Item Name' ref={createItemNameRef} required></IonInput>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel className="form-label" position="stacked">Item Description: </IonLabel>
                                                <IonInput className='professional-input' placeholder='Enter Item Description' ref={createItemDescriptionRef} required></IonInput>
                                            </IonCol>
                                        </IonRow>

                                             {/*<IonRow>
                                                <IonCol size='12'>
                                                    <IonButton  onClick={() => setShowSupplierModal(true)}> Add Supplier</IonButton>
                                                </IonCol>
                                            </IonRow>
                                           <IonRow>
                                                <IonCol>
                                                    <h3 >Supplier Part Number:</h3>
                                                </IonCol>
                                                <IonCol>
                                                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={vendorPartNumRef}></IonInput>
                                                </IonCol>
                                            </IonRow>*/}
                                            {/*<IonRow>
                                                <IonCol size='12'>
                                                    <IonLabel className="form-label" position="stacked" for='searchSupplierName' required>Supplier Name:</IonLabel>
                                                    <IonInput className='professional-input' type='text' id='searchSupplierName' ref={ vendorNameRef } placeholder='Search supplier name' onIonInput={() => handleInput(['name', vendorNameRef.current.value])} list='searchSupplierNameList' autocomplete='off' required></IonInput>
                                                    <datalist id='searchSupplierNameList'>
                                                        {searchResults.map((result) => (
                                                            <option key={result.db_supplierId} value={result.db_supplierName}></option>
                                                        ))}
                                                    </datalist>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol size='12'>
                                                    <IonLabel className="form-label" position="stacked" for='searchSupplierPhoneNumber' required>Supplier Phone Number:</IonLabel>
                                                    <IonInput className='professional-input' type='text' id='searchSupplierPhoneNumber' ref={ vendorPhoneNumberRef }  placeholder='Search supplier phone number' onIonInput={() => handleInput(['phone', vendorPhoneNumberRef.current.value])} list='searchSupplierPhoneNumberList' autocomplete='off' required></IonInput>
                                                    <datalist id='searchSupplierPhoneNumberList'>
                                                        {searchResults.map((result) => (
                                                            <option key={result.db_supplierId} value={result.db_supplierPhoneNumber}></option>
                                                        ))}
                                                    </datalist>
                                                </IonCol>
                                            </IonRow>*/}
                                            {/*<IonRow>
                                                <IonCol>
                                                    <h3>Supplier Address:</h3>
                                                </IonCol>
                                                <IonCol>
                                                    <input type='text' ref={ vendorAddressRef } placeholder='Vendor Address' autocomplete='off' required></input>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol>
                                                    <h3>Supplier City:</h3>
                                                </IonCol>
                                                <IonCol>
                                                    <input type='text' ref={ vendorCityRef } placeholder='Vendor City' autocomplete='off' required></input>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol>
                                                    <h3>Supplier Country:</h3>
                                                </IonCol>
                                                <IonCol>
                                                    <input type='text' ref={ vendorCountryRef } placeholder='Vendor Country' autocomplete='off' required></input>
                                                </IonCol>
                                            </IonRow>*/}

                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel className="form-label" position="stacked">Cost Per Unit:  </IonLabel>
                                                 <IonInput className='professional-input' type='number' step='any' placeholder='Enter Cost Per Unit' ref={itemCostPerUnitRef} required></IonInput>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonLabel className="form-label" position="stacked">Qty In stock:  </IonLabel>
                                                <IonInput className='professional-input' type='number' placeholder='Enter Quantity In Stock' ref={itemQtyInStockRef}></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonLabel className="form-label" position="stacked" for="qtyUnitsRef">Qty Units </IonLabel>
                                                {/*<select name="employeeRole" id='employeeRole' ref={(e) => handleCreateEmployeeCompanyRole(e) }>*/}
                                                <select className='professional-input' name="qtyUnitsRef" id='qtyUnitsRef' ref={qtyUnitsRef}>
                                                    <option value='ea' selected>Quantity</option>
                                                    <option value='g'>grams</option>
                                                    <option value='kg'>Kilograms</option>
                                                    <option value='L'>Liters</option>
                                                </select>
                                            </IonCol>
                                        </IonRow>
                                        {/*<IonRow>
                                            <IonCol size='12'>
                                                <IonLabel className="form-label" position="stacked">Upload Supporting Documentation</IonLabel>
                                                <IonInput className='professional-input' type='file' name='imageFile' accept="image/*" onIonChange={(e) => selectedFileHandler(e.target.files[0])}></IonInput>
                                            </IonCol>
                                        </IonRow>*/}
                                        <IonRow>
                                            <IonCol size='12'>
                                            {   (authenticatedMerchent_context.initialSetup?.details?.step_1 == true && authenticatedMerchent_context.initialSetup?.details?.step_2 == false) || (
                                                (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '1' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                            ) ? <IonButton type='submit' className='flash-tutorial' > Confirm Item Creation </IonButton> 
                                            : <IonButton type='submit'> Confirm Item Creation </IonButton> }

                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>                        
                            
                                <AddSupplierModal  openModal={ showSupplierModal } closeModal={() => setShowSupplierModal(false)}></AddSupplierModal>

                    </IonContent>
                    <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonButton onClick={() => props.closeModal(false)}>Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>
                    </form>
                </IonModal>) : null
                }
            </React.Fragment>

    )
}